import React, { useRef } from "react";
// import "./FormNotificationMemberTeam.scss";

import classNames from "classnames";
import CreatableSelect from "react-select/creatable";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";

import { Button } from "src/app/components/Button/Button";

import { translateMessage } from "src/app/methods/translateMessage";
import { ReactComponent as EnvelopeIcon } from "src/images/envelope.svg";
import { ReactComponent as CloseIcon } from "src/images/mutableCloseIcon.svg";
import { useIntl } from "react-intl";
import { inviteSelectStyles } from "src/app/modals/ShareModal/InviteUser/utils/inviteSelectStyles";
import { StackedAvatars } from "../StackedAvatars/StackedAvatars";

function SelectMemberOrTeam(props) {
  const {
    selectedOptions,
    setSelectedOptions,
    members,
    teams,
    membersWithNotification,
    addButtonClick,
  } = props;

  const selectRef = useRef(null);
  const valueContainerRef = useRef(null);
  const anchorRef = useRef(null);

  const intl = useIntl();

  const filterOption = (candidate, input) => {
    return (
      candidate.data.name?.toLowerCase().includes(input.toLowerCase()) ||
      candidate.data.email?.toLowerCase().includes(input.toLowerCase())
    );
  };

  const prepareData = () => {
    const groupedOptions = [
      {
        label: "Teams",
        options: teams
          // ?.filter(
          //   (identityTeam) =>
          //     !membersWithNotification?.find(
          //       (memberTeamRow) =>
          //         memberTeamRow.wsTeamUuid === identityTeam.uuid,
          //     ) && identityTeam,
          // )
          .map((team) => ({
            name: team.name,
            label: team.name,
            value: team.uuid,
            members: team.wsMembers,
            type: "team",
          })),
      },
      {
        label: "Members",
        options: members
          ?.filter(
            (identityMember) =>
              !membersWithNotification?.find(
                (memberId) => memberId === identityMember.id,
              ) && identityMember,
          )
          .map((member) => ({
            label: member.name,
            name: member.name,
            email: member.email,
            value: member.id,
            avatarUrl: member.avatarUrl,
            type: "member",
            members: [],
          })),
      },
    ];

    return groupedOptions;
  };

  const formatOptionLabel = (option) => (
    <div className="notification-members__label-row">
      <div className="notification-members__label-row-name">{option.label}</div>
      {option.type === "team" ? (
        <StackedAvatars
          avatars={option.members?.map((member) => ({
            url: member?.avatarUrl,
          }))}
          maxAvatars={5}
        />
      ) : (
        <StackedAvatars avatars={[{ url: option?.avatarUrl }]} maxAvatars={1} />
      )}
    </div>
  );

  return (
    <div className="notification-members__user-select" ref={valueContainerRef}>
      <div className="notification-members__user-select-row">
        <div className="notification-members__add-container-member-list">
          <CreatableSelect
            className={classNames(["notification-members__user-select-input"])}
            closeMenuOnSelect={false}
            components={{
              DropdownIndicator: () => null,
              IndicatorSeparator: () => null,
              ClearIndicator: () => null,
              MultiValueRemove: (props) => (
                <div {...props.innerProps}>
                  <CloseIcon
                    {...props}
                    width={16}
                    height={16}
                    fill={props.data.color || "#8E93AC"}
                  />
                </div>
              ),
            }}
            value={selectedOptions}
            isSearchable
            isMulti
            withTiles
            onChange={setSelectedOptions}
            options={prepareData()}
            placeholder={translateMessage({
              intl,
              id: "ws_select_member",
              defaultMessage: "Select member",
            })}
            filterOption={filterOption}
            openMenuOnFocus
            menuPortalTarget={document.querySelector(".Overlays") || undefined}
            ref={selectRef}
            styles={inviteSelectStyles}
            formatOptionLabel={formatOptionLabel}
            formatCreateLabel={(inputText) => (
              <div className="teams__user-select-invite">
                <EnvelopeIcon className="teams__user-select-invite-env" />
                <IDHFormattedMessage id="ws_invite" defaultMessage="Invite" />
                <div className="teams__user-select-invite-email">
                  {inputText}
                </div>
              </div>
            )}
          />
        </div>
        <div className="notification-members__add-container-btn">
          <Button
            variant="blue"
            size="large"
            disabled={!(selectedOptions.length > 0)}
            onClick={addButtonClick}
          >
            <IDHFormattedMessage id="ws_add" defaultMessage="Add" />
          </Button>
        </div>
      </div>
      <div
        className="notification-members__user-select__anchor"
        ref={anchorRef}
      />
    </div>
  );
}

export default SelectMemberOrTeam;
